import dayjs from 'dayjs'

import { FormattedSlot } from '@/apiTypes.ts'
import { SortedSlotGroup } from '@/store.ts'

export const groupSlotsByDate = (slots: FormattedSlot[]) => {
  // Group filtered slots by date
  const slotsByDate: { [key: string]: FormattedSlot[] } = {}
  slots.forEach((slot) => {
    const dateKey = dayjs(slot.start).format('dddd, D MMMM YYYY')
    if (!slotsByDate[dateKey]) {
      slotsByDate[dateKey] = []
    }
    slotsByDate[dateKey].push(slot)
  })

  // Create sorted slot groups
  const sortedSlotGroups: SortedSlotGroup[] = Object.entries(slotsByDate).map(
    ([date, slots]) => ({
      date,
      slots: slots.sort((a, b) => a.start.valueOf() - b.start.valueOf()),
    }),
  )

  // Sort the days
  sortedSlotGroups.sort(
    (a, b) =>
      dayjs(a.date, 'dddd, D MMMM YYYY').valueOf() -
      dayjs(b.date, 'dddd, D MMMM YYYY').valueOf(),
  )

  return sortedSlotGroups
}
